import React from 'react';
import {Header,Item, Label,  Breadcrumb, Embed, Transition, Icon, Segment,Container, Loader,Image, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio, Message} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import Content from '../NetflixSlider/ContentHeader';
import Slider from '../NetflixSlider'; 
import ModulosCurso from './ModulosCurso';
import SlideShow from 'react-slideshow-ui';
import Crossword from '@jaredreisinger/react-crossword';
import Quiz from 'react-quiz-component';
import moment from 'moment';
import { Document, Page } from 'react-pdf';
import ReactPlayerSin from 'react-player/lazy'
import $ from 'jquery';


$(document).ready(function(){

        $('#videoElementID').bind('contextmenu',function() { return false; });
    });



const CursoView=({ id, color, ajaxCallInProgress, strings, permisos, regresar, visible, onAcordionModulo, modulos,cursosActuales,
                    cursosPrevios,  form, onSave,onChange, datos, errors, fechaActual, 
                    moduloActivo,onAcordionModuloOff,contenidoView,modulo,onAcordionContenido,contenidoActivo, contenido,agrupador,onAcordionContenidoOff, onHandleFile, imgPresentacion, 
                    handleChangeFile, onSaveOrden, onSaveOrdenModulo, onSaveOrdenContenido, onShowModal,onCloseModal, saveImage, onEliminar, onEliminarModulo})=>{

  return (
        <div>
            <Dimmer.Dimmable dimmed={ajaxCallInProgress>0?true:false}>
                <br/>
      
                 <Link to="/cursoscatn">
                    <Button color='instagram' fluid size='large' >
                        {strings?strings["regresar"]:""}
                    </Button>
                </Link>
      
              
      
                <Grid>
                    <Grid.Row only='computer tablet'>
                        <Grid.Column textAlign="center" width={16}>
                            <Segment>
                            {imgPresentacion.imagePreviewUrl!=null?
                                <center>
                                    <Image src={imgPresentacion.imagePreviewUrl} size="big" fluid />
                              
                                </center>
                            :
                                "Sin imagen"
                            }
                            
                            <Form.Field  >
                                <label>{strings?strings["nuevafoto"]:""} </label>
                                <Input placeholder='questionPic'
                                name="questionPic"
                                type='file'
                                onChange={handleChangeFile}
                                />        
                                <Button color="black"  size='large' onClick={saveImage} >
                                        {strings?strings["guardar"]:""}
                                </Button>
      
                            </Form.Field>
                            </Segment>
      
                        </Grid.Column>
                    </Grid.Row>  

                </Grid>

      
            {visible?
                <ModulosCurso 
                    modulos={modulos} 
                    onAcordionModulo={onAcordionModulo}
                    fechaActual={fechaActual}
                    moduloActivo={moduloActivo}
                    onAcordionModuloOff={onAcordionModuloOff}
                    contenidoView={contenidoView}
                    modulo={modulo}
                    onAcordionContenido={onAcordionContenido}
                    contenidoActivo={contenidoActivo}
                    contenido={contenido}
                    agrupador={agrupador}
                    onAcordionContenidoOff={onAcordionContenidoOff}
                    onSaveOrden={onSaveOrden}
                    onSaveOrdenModulo={onSaveOrdenModulo}
                    onSaveOrdenContenido={onSaveOrdenContenido}
                    onShowModal={onShowModal}
                    onCloseModal={onCloseModal}
                    onEliminar={onEliminar}
                    onEliminarModulo={onEliminarModulo}
                    />
            :
                ""
            }
                 

            </Dimmer.Dimmable>
        


        
      
        </div>
	);
};



export default CursoView;